import { useForm } from 'react-hook-form'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import FirstName from 'components/RCPro/components/form/FirstName/FirstName'
import LastName from 'components/RCPro/components/form/LastName/LastName'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import { nextPage } from 'components/RCPro/helpers/nav'

const RCProCustomer = () => {
  const navigate = useNavigate()
  const [ nextPageTransition ] = useOutletContext()
  const { state, pathname } = useLocation()
  const { customer, layout: { next } } = state.texts

  // Initialize form
  const {
    register,
    formState: { errors, isValid },
    handleSubmit
  } = useForm({
    ...formParams,
    values: {
      firstname: state.firstname,
      lastname: state.lastname
    },
  })

  const onSubmit = handleSubmit(async data => {
    nextPage({ pathname, state, navigate, data })
    nextPageTransition()
  })

  return (
    <>
      <h1>{customer.title} 🙋</h1>

      <form onSubmit={onSubmit}>
        <FirstName
          register={register}
          error={errors.firstname}
        />

        <LastName
          register={register}
          error={errors.lastname}
        />

        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProCustomer